import { useEffect, useState } from "react";

const navLinks = [
  { label: "今日缘分", href: "#fate" },
  { label: "盲盒番剧", href: "#blindbox" },
  { label: "随缘漫游", href: "#roam" },
  { label: "热门推荐", href: "#popular" },
  { label: "动漫分类", href: "#categories" },
  { label: "关于我们", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            go("#top");
          }}
          className="flex items-center gap-2.5 cursor-pointer"
        >
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-sm">
            <i className="ri-clapperboard-line text-lg md:text-xl"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide transition-colors ${
              scrolled || open ? "text-foreground-950" : "text-white"
            }`}
          >
            小缘动漫库
          </span>
        </a>

        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => {
                e.preventDefault();
                go(l.href);
              }}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-primary-500 cursor-pointer ${
                scrolled || open ? "text-foreground-700" : "text-white/90"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#fate"
            onClick={(e) => {
              e.preventDefault();
              go("#fate");
            }}
            className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold px-5 py-2.5 transition-colors cursor-pointer"
          >
            <i className="ri-heart-3-line"></i>
            开启缘分
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg border border-background-200 bg-background-50/70 text-foreground-800 cursor-pointer"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4 space-y-1">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => {
                e.preventDefault();
                go(l.href);
              }}
              className="block px-3 py-2.5 rounded-lg text-foreground-800 text-sm font-medium hover:bg-background-100 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#fate"
            onClick={(e) => {
              e.preventDefault();
              go("#fate");
            }}
            className="block px-3 py-2.5 mt-1 rounded-full bg-primary-500 text-background-50 text-sm font-semibold text-center cursor-pointer"
          >
            开启缘分
          </a>
        </div>
      )}
    </header>
  );
}